import { useBlockProps, BlockControls, InnerBlocks } from "@wordpress/block-editor";
import { ToolbarGroup, Button as WPButton } from "@wordpress/components";
import SidePanel from "./sidePanel";
import { t } from "drupal";
import { useSelect } from "@wordpress/data";
import { store as blockEditorStore } from "@wordpress/block-editor";
import CustomRepater from "./customRepeater.js";

function Edit({ attributes, setAttributes, clientId }) {

  const BLOCK_LABELS = {
    "deohs-gutenberg-blocks/deohs-button": "Button block"
  };

  /**
  *  Core and custom blocks that are allowed inside the parent block.
  **/
  const ALLOWED_BLOCKS = [
    'core/paragraph',
    'core/heading',
    'core/image',
    'deohs-gutenberg-blocks/deohs-button',
    'core/html',
    'core/spacer'
  ]

  /**
  *  Check for invalid blocks inside the parent block.
  **/
  const invalidBlocks = useSelect((select) => {
      const { getBlocks } = select(blockEditorStore);
      const innerBlocks = getBlocks(clientId);

      return innerBlocks
        .filter((block) => {
          const { name, attributes } = block;

          switch (name) {
            case "deohs-gutenberg-blocks/deohs-button":
              return attributes.ctaError || attributes.ctaUrlError;
            default:
              return false;
          }
        })
        .map((block) => BLOCK_LABELS[block.name] || block.name); // Map to readable labels
    }, [clientId]);



  return (
    <div {...useBlockProps()}>
      {/* This is the side panel of call out box */}
      <BlockControls>
        <ToolbarGroup>
          <WPButton
            label={t("Call out box Settings")}
            icon="text"
            disabled
          />
        </ToolbarGroup>
      </BlockControls>

      {/* If there are any errors in child blocks, dispay error message(s) */}

      {invalidBlocks.length > 0 && (
        <div className="parent-block-container-error">
          <p>The following blocks have errors and must be fixed before saving:</p>
          <ul>
            {invalidBlocks.map((blockName, index) => (
              <li key={index}>{blockName}</li>
            ))}
          </ul>
        </div>
      )}

      {/* This is the HTML markup of the call out box. */}

      <div className="biobox" role="complementary">
        <InnerBlocks
          allowedBlocks={ALLOWED_BLOCKS}
          templateLock={false}
          renderAppender={false}        />
        <CustomRepater />
      </div>

      {/* Sidebar Controls */}
      <SidePanel />
    </div>
  );
}

export default Edit;
